import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { DocumentModel } from '../../../shared/models/document.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { OccupationModel } from 'src/app/shared/models/occupation.model';
import { IProductsModel } from '../../../shared/models/products.model';
import { BioCatchService } from '../../../shared/services/external/biocatch/biocatch.service';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { ProductsBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
import { callbackAdjustContratarTC } from 'src/app/shared/constants/adjust-callback';
import { AdjustEvent } from 'src/app/shared/services/external/adjust/adjust.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';

/**
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
@Component({
  selector: 'app-request-received',
  templateUrl: './request-received.component.html',
  styleUrls: ['./request-received.component.scss'],
})

/**
 * Clase del componente de introducción al escaneo del documento
 *
 * *Document introduction component class*
 */
export class RequestReceivedComponent implements OnInit {
  documentInfo: DocumentModel;
  dataClient: any;
  options: any = [];
  product_type: string;
  product_code: string;
  pcoStatusCode: string;
  occupationSelected: OccupationModel;
  nextCode: string;
  data: any;
  mobilePhoneOffice: any;
  basicDataRequest: boolean;
  contactDataUpdate: boolean;
  addreessesDataUpdate: boolean;
  financialDataUpdate: boolean;
  pcoAmountValidation: boolean;
  bondingFlow: boolean;
  productSelected: IProductsModel;
  inferredIncomes: any;
  solicitationNumber: string;
  grayZone: boolean;
  currentDate: string;
  ipAddress: string;
  postLogin: any;

  /**
   * Constructor of the component.
   *
   * @param {HeaderService}     headerService     Injectable headerService service.
   * @param {NavigationService} navigationService Injectable navigationService service.
   * @function headerService.show() Hides header
   */
  constructor(
    public copyService: CopyService,
    private navigationService: NavigationService,
    private headerService: HeaderService,
    private abreCuentasService: AbreCuentasService,
    private biocatchService: BioCatchService,
    private adjustEvent: AdjustEvent,
    private taggingService: TaggingService,
  ) {
    this.headerService.show(false, false, false);
    this.solicitationNumber = this.abreCuentasService.getAbreCuentasModel().solicitationId;
  }

  ngOnInit(): void {
    this.sendTagging('init');
    this.grayZone = this.abreCuentasService.isGrayZone();
    this.postLogin = this.abreCuentasService.getPostlogin();
    const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
    if (product === 'TCR' && !this.postLogin === true && this.grayZone === true) {
      this.navigationService.pageLoadTag(false, ['pv419', '', '', '']);
      // this.navigationService.getCurrentStep().tag_name
      //   = this.abreCuentasService.getProspectResponse().client ? 'pv454' : 'pv419';
    } else if (product === 'TCR' && this.postLogin === true && this.grayZone === true) {
      this.navigationService.pageLoadTag(false, ['pv454', '', '', '']);
    } else if (product === 'TCR' && this.postLogin === true && !this.grayZone === true) {
      this.navigationService.pageLoadTag('SolicitudRecibida', ['pv457', '', '', '']);
    }
    console.log('adjust 263');
    console.log(this.navigationService.getCurrentStep().tag_name);
    const productSelected = this.abreCuentasService.getproductSelected().product_type;
    if (productSelected === BUSINESS_CONST.PRODUCT_TYPE_TC) {
      const event = {
        eventToken: '1hffh6',
        callbackParams: callbackAdjustContratarTC,
      };
      this.adjustEvent.adjustTrackEvent(event);
    }

    this.documentInfo = this.abreCuentasService.getDocumentInfo();
    this.currentDate = this.abreCuentasService.formatDateSpanish(true, new Date());
    this.ipAddress = this.biocatchService.getCurrentScoreIp();
  }

  /**
   * event next step
   */
  nextYes() {
    this.navigationService.nextStep('200');
  }

  closeApp() {
    this.navigationService.loadExitScreen = true;
  }

  handleError() {
    this.abreCuentasService.hideGenericLoading();
    this.navigationService.navigateToGeneralInformation('500');
  }

  sendTagging(value: any, position?: string, event?: string) {
    const grayZone = this.abreCuentasService.isGrayZone();
    const page = grayZone ? '23' : '22';
    const extras = {
      pageValue: 'RequestReceived' + (grayZone ? 'GrayZone' : ''),
    };
    this.taggingService.sendTaggValues(value, page, position, event, extras);
  }
}
